import { login as v1Login, logout, currentUser } from '../../api/v1/auth';
import { disablePush } from '../../core/webNotifications';

// loginSuccess ya no guarda nada: api/v1/auth guarda la sesión al iniciar.
export function loginSuccess() {
   this.setState({ auth: true });
}

export { v1Login as login };

export async function logOut() {
   // Antes de borrar el token: da de baja las notificaciones de este navegador.
   // Sin esperar más de 3 s: cerrar sesión no depende de la red.
   await Promise.race([disablePush(), new Promise((r) => setTimeout(r, 3000))]);
   logout();
   this.setState({
      auth: false,
      token: undefined,
   });
   window.location = '/login';
}

export async function getId() {
   const user = await currentUser();
   return user.IdPersona;
}

export async function loadUser() {
   return currentUser();
}
